/* eslint-disable no-useless-catch */
import { BusinessLevels } from '../common/types';
import { appConfig } from '../config/app-config';
import { callApi } from '../common/api';
import { API_END_POINTS } from '../config/api-endpoints';

export const getPdf = async (
  businessLevel: BusinessLevels,
  business: string,
  invoiceId: string,
  businessId: string,
): Promise<Blob | undefined> => {
  const params = {
    id: invoiceId,
    templateId: appConfig.INVOICE_PDF_TEMPLATE_ID,
  };

  let headers: any = {
    'node-id': businessId,
    'node-type': businessLevel,
  };
  switch (businessLevel) {
    case BusinessLevels.PAN:
      headers = {
        ...headers,
        PAN: business,
      };
      break;
    case BusinessLevels.GSTIN:
      headers = {
        ...headers,
        GSTIN: business,
      };
      break;
    case BusinessLevels.BRANCH:
      headers = {
        ...headers,
        BRANCH: business,
      };
      break;
  }

  const response = await callApi({
    method: 'GET',
    url: API_END_POINTS.EINVOICE.PRINT,
    headers,
    params,
    responseType: 'blob',
  });
  if (response.status === 200) {
    return response.data;
  }
  throw new Error('Failed to download pdf');
};

const getSupplierGstNumber = ()=> {
  try {
    return JSON.parse(localStorage.getItem('HEADER_DATA') || '{}')?.gstin || '';
  } catch(e){
    return '';
  }
}

const replaceSlashWithUnderscoreInInvoiceNo = (invoiceNumber: string)=> invoiceNumber?.replaceAll('/','_')?.trim();

export const downloadPdf = async (
  businessLevel: BusinessLevels,
  business: string,
  invoiceId: string,
  invoiceNumber: string, 
  buyerGstin: string,
  invoiceType: string,
  businessId: string,
) => {
  const blob = await getPdf(businessLevel, business, invoiceId, businessId);
  const supplierGstin = getSupplierGstNumber()
  const formattedInvoiceNumber = replaceSlashWithUnderscoreInInvoiceNo(
    invoiceNumber
  );
  if (blob) {
    try {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${invoiceType}_${buyerGstin}_${supplierGstin}_${formattedInvoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      // @ts-ignore
      link.parentNode.removeChild(link);
    } catch (e) {
    //   console.log('Failed to download pdf');
      throw e;
    }
  }
};
